<template>
  <div class="container">
    <div class="top-cont">
      <div class="btn-cont">
        <el-button class="btn" size="medium" icon="el-icon-arrow-left" round @click="handleBack">返回</el-button>
      </div>
    </div>
    <div class="content-box--wrap">
      <div class="content-box" ref="chatBoxCont">
        <el-backtop :right="60" :bottom="150" target=".content-box" />
        <div class="content">
          <!--未开始聊天时的提示-->
          <div class="tip-cont" v-if="!initChat">
            <div class="title">我是有教灵境AI智能体,很高兴见到你!</div>
            <div class="tag">已接入DeepSeek</div>
            <div class="text">让我们开始聊天吧~~</div>
          </div>
          <!--聊天记录-->
          <div class="chat-cont" v-else>
            <div class="item-chat--box" v-for="(item, inx) in chatList" :key="inx">
              <div class="user-key--cont">
                <div class="user-key">{{ item.key }}</div>
              </div>
              <div class="item-chat">
                <div class="avatar">
                  <el-avatar src="https://cdn.xiaowei.qq.com/static/lke/app-default-avatar.png"></el-avatar>
                </div>
                <div class="answer-cont">
                  <div class="loading-cont box" @click="changeThinkStat(item)">
                    <template v-if="!item.stopCreate">
                      <template v-if="item.isThinking">
                        <i class="el-icon-loading"></i>思考中...
                      </template>
                      <template v-else>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.656 17.344c-1.016-1.015-1.15-2.75-.313-4.925.325-.825.73-1.617 1.205-2.365L3.582 10l-.033-.054c-.5-.799-.91-1.596-1.206-2.365-.836-2.175-.703-3.91.313-4.926.56-.56 1.364-.86 2.335-.86 1.425 0 3.168.636 4.957 1.756l.053.034.053-.034c1.79-1.12 3.532-1.757 4.957-1.757.972 0 1.776.3 2.335.86 1.014 1.015 1.148 2.752.312 4.926a13.892 13.892 0 0 1-1.206 2.365l-.034.054.034.053c.5.8.91 1.596 1.205 2.365.837 2.175.704 3.911-.311 4.926-.56.56-1.364.861-2.335.861-1.425 0-3.168-.637-4.957-1.757L10 16.415l-.053.033c-1.79 1.12-3.532 1.757-4.957 1.757-.972 0-1.776-.3-2.335-.86zm13.631-4.399c-.187-.488-.429-.988-.71-1.492l-.075-.132-.092.12a22.075 22.075 0 0 1-3.968 3.968l-.12.093.132.074c1.308.734 2.559 1.162 3.556 1.162.563 0 1.006-.138 1.298-.43.3-.3.436-.774.428-1.346-.008-.575-.159-1.264-.449-2.017zm-6.345 1.65l.058.042.058-.042a19.881 19.881 0 0 0 4.551-4.537l.043-.058-.043-.058a20.123 20.123 0 0 0-2.093-2.458 19.732 19.732 0 0 0-2.458-2.08L10 5.364l-.058.042A19.883 19.883 0 0 0 5.39 9.942L5.348 10l.042.059c.631.874 1.332 1.695 2.094 2.457a19.74 19.74 0 0 0 2.458 2.08zm6.366-10.902c-.293-.293-.736-.431-1.298-.431-.998 0-2.248.429-3.556 1.163l-.132.074.12.092a21.938 21.938 0 0 1 3.968 3.968l.092.12.074-.132c.282-.504.524-1.004.711-1.492.29-.753.442-1.442.45-2.017.007-.572-.129-1.045-.429-1.345zM3.712 7.055c.202.514.44 1.013.712 1.493l.074.13.092-.119a21.94 21.94 0 0 1 3.968-3.968l.12-.092-.132-.074C7.238 3.69 5.987 3.262 4.99 3.262c-.563 0-1.006.138-1.298.43-.3.301-.436.774-.428 1.346.007.575.159 1.264.448 2.017zm0 5.89c-.29.753-.44 1.442-.448 2.017-.008.572.127 1.045.428 1.345.293.293.736.431 1.298.431.997 0 2.247-.428 3.556-1.162l.131-.074-.12-.093a21.94 21.94 0 0 1-3.967-3.968l-.093-.12-.074.132a11.712 11.712 0 0 0-.71 1.492z"
                            fill="currentColor"
                            stroke="currentColor"
                            stroke-width=".1"
                          />
                          <path
                            d="M10.706 11.704A1.843 1.843 0 0 1 8.155 10a1.845 1.845 0 1 1 2.551 1.704z"
                            fill="currentColor"
                            stroke="currentColor"
                            stroke-width=".2"
                          />
                        </svg>
                        <span class="time-text">{{ `已深度思考（用时 ${item.timer} 秒）` }}</span>
                      </template>
                    </template>
                    <template v-else>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.656 17.344c-1.016-1.015-1.15-2.75-.313-4.925.325-.825.73-1.617 1.205-2.365L3.582 10l-.033-.054c-.5-.799-.91-1.596-1.206-2.365-.836-2.175-.703-3.91.313-4.926.56-.56 1.364-.86 2.335-.86 1.425 0 3.168.636 4.957 1.756l.053.034.053-.034c1.79-1.12 3.532-1.757 4.957-1.757.972 0 1.776.3 2.335.86 1.014 1.015 1.148 2.752.312 4.926a13.892 13.892 0 0 1-1.206 2.365l-.034.054.034.053c.5.8.91 1.596 1.205 2.365.837 2.175.704 3.911-.311 4.926-.56.56-1.364.861-2.335.861-1.425 0-3.168-.637-4.957-1.757L10 16.415l-.053.033c-1.79 1.12-3.532 1.757-4.957 1.757-.972 0-1.776-.3-2.335-.86zm13.631-4.399c-.187-.488-.429-.988-.71-1.492l-.075-.132-.092.12a22.075 22.075 0 0 1-3.968 3.968l-.12.093.132.074c1.308.734 2.559 1.162 3.556 1.162.563 0 1.006-.138 1.298-.43.3-.3.436-.774.428-1.346-.008-.575-.159-1.264-.449-2.017zm-6.345 1.65l.058.042.058-.042a19.881 19.881 0 0 0 4.551-4.537l.043-.058-.043-.058a20.123 20.123 0 0 0-2.093-2.458 19.732 19.732 0 0 0-2.458-2.08L10 5.364l-.058.042A19.883 19.883 0 0 0 5.39 9.942L5.348 10l.042.059c.631.874 1.332 1.695 2.094 2.457a19.74 19.74 0 0 0 2.458 2.08zm6.366-10.902c-.293-.293-.736-.431-1.298-.431-.998 0-2.248.429-3.556 1.163l-.132.074.12.092a21.938 21.938 0 0 1 3.968 3.968l.092.12.074-.132c.282-.504.524-1.004.711-1.492.29-.753.442-1.442.45-2.017.007-.572-.129-1.045-.429-1.345zM3.712 7.055c.202.514.44 1.013.712 1.493l.074.13.092-.119a21.94 21.94 0 0 1 3.968-3.968l.12-.092-.132-.074C7.238 3.69 5.987 3.262 4.99 3.262c-.563 0-1.006.138-1.298.43-.3.301-.436.774-.428 1.346.007.575.159 1.264.448 2.017zm0 5.89c-.29.753-.44 1.442-.448 2.017-.008.572.127 1.045.428 1.345.293.293.736.431 1.298.431.997 0 2.247-.428 3.556-1.162l.131-.074-.12-.093a21.94 21.94 0 0 1-3.967-3.968l-.093-.12-.074.132a11.712 11.712 0 0 0-.71 1.492z"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width=".1"
                        />
                        <path
                          d="M10.706 11.704A1.843 1.843 0 0 1 8.155 10a1.845 1.845 0 1 1 2.551 1.704z"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width=".2"
                        />
                      </svg>
                      <span class="time-text">思考已停止</span>
                    </template>
                    <template v-if="item.showThink">
                      <span class="el-icon-arrow-up thinkIcon"></span>
                    </template>
                    <template v-else>
                      <span class="el-icon-arrow-down thinkIcon"></span>
                    </template>
                  </div>
                  <!--ai思考-->
                  <div class="thought-cont" v-if="item.showThink">
                    <div
                      class="thought-text"
                      v-for="(v, index) in item.thoughtWsArr"
                      :key="index"
                    >{{ v.debugging.content }}</div>
                  </div>
                  <!--ai回复-->
                  <div
                    class="desc-cont box"
                    v-loading="item.lonading"
                    element-loading-text="回答中..."
                    element-loading-spinner="el-icon-loading"
                  >
                    <div class="desc-text" :ref="`output${inx}`"></div>
                  </div>
                  <!--信息来源-->
                  <template v-if="item.initSource">
                    <div class="refe-cont box">
                      <div class="refe-text" v-for="(ele, indx) in item.sourceList" :key="indx">
                        <el-link :href="ele.url" target="_blank" type="primary" :underline="false">
                          <div class="icons-cont">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="10"
                                cy="10"
                                r="9"
                                stroke="currentColor"
                                stroke-width="1.8"
                              />
                              <path
                                d="M10 1c1.657 0 3 4.03 3 9s-1.343 9-3 9M10 19c-1.657 0-3-4.03-3-9s1.343-9 3-9M1 10h18"
                                stroke="currentColor"
                                stroke-width="1.8"
                              />
                            </svg>
                            <span>-</span>
                          </div>
                          <div class="name">{{ ele.name }}</div>
                        </el-link>
                      </div>
                    </div>
                  </template>
                  <div class="tool-cont">
                    <div class="left-icons--box">
                      <div class="icons" @click="handleCopy(inx)">
                        <el-tooltip content="复制" placement="top" v-tooltipHide :hide-after="1500">
                          <i class="el-icon-copy-document"></i>
                        </el-tooltip>
                      </div>
                      <div class="icons" @click="resetContinue(item, inx)">
                        <el-tooltip content="重新生成" placement="top" v-tooltipHide :hide-after="1500">
                          <i class="el-icon-refresh"></i>
                        </el-tooltip>
                      </div>
                      <template v-if="!item.isError">
                        <div class="icons" @click="giveLike(item)">
                          <el-tooltip content="喜欢" placement="top" v-tooltipHide :hide-after="1500">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.5 18c-.663 0-1.298-.294-1.767-.815A2.944 2.944 0 0 1 0 15.222V8.777c0-.737.263-1.443.732-1.964C1.202 6.293 1.837 6 2.5 6s1.299.293 1.768.813A2.94 2.94 0 0 1 5 8.777v6.445c0 .737-.264 1.443-.733 1.963-.469.521-1.104.814-1.767.815zm0-10.308a.934.934 0 0 0-.693.319c-.183.204-.287.48-.287.77v6.445c0 .288.103.565.287.77.184.204.433.319.693.32.26-.001.51-.116.693-.32.183-.205.287-.482.287-.77V8.78c0-.143-.025-.285-.074-.417a1.105 1.105 0 0 0-.212-.354.981.981 0 0 0-.318-.237.897.897 0 0 0-.376-.084v.004z"
                                fill="currentColor"
                              />
                              <path
                                d="M10.352 18H7.564a3.539 3.539 0 0 1-2.519-1.062A3.658 3.658 0 0 1 4 14.378V8.281c0-.884.177-1.76.523-2.572l1.911-4.502c.142-.334.371-.622.662-.834A1.949 1.949 0 0 1 9.122.21c.32.163.59.411.782.719l.171.271c.194.312.298.673.298 1.041v1.755c0 .341.134.669.371.91.238.242.56.378.896.378h2.691a3.64 3.64 0 0 1 2.594 1.092A3.76 3.76 0 0 1 18 9.014a7.267 7.267 0 0 1-1.288 4.147l-1.602 2.325a5.84 5.84 0 0 1-2.076 1.848 5.735 5.735 0 0 1-2.682.666zM8.245 1.648h-.03a.331.331 0 0 0-.293.212L6.012 6.36a4.882 4.882 0 0 0-.39 1.92v6.095c0 .524.205 1.026.569 1.396.364.37.858.579 1.373.58h2.788c.672-.001 1.335-.166 1.931-.481a4.208 4.208 0 0 0 1.495-1.332l1.603-2.324a5.616 5.616 0 0 0 .994-3.201 2.1 2.1 0 0 0-.6-1.472 2.031 2.031 0 0 0-1.448-.61h-2.691c-.766-.001-1.5-.31-2.042-.861a2.964 2.964 0 0 1-.847-2.075V2.241a.297.297 0 0 0-.046-.16l-.17-.272a.334.334 0 0 0-.286-.16z"
                                fill="currentColor"
                              />
                            </svg>
                          </el-tooltip>
                        </div>
                        <div class="icons" @click="handleDisagree(item)">
                          <el-tooltip
                            content="不喜欢"
                            placement="top"
                            v-tooltipHide
                            :hide-after="1500"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                              <path
                                id="path"
                                d="M3.71 13.17C3.53 13.17 3.36 13.16 3.18 13.12C3.01 13.09 2.84 13.04 2.67 12.97C2.51 12.9 2.35 12.82 2.2 12.72C2.05 12.62 1.92 12.51 1.79 12.38C1.66 12.25 1.55 12.12 1.45 11.97C1.35 11.82 1.27 11.67 1.2 11.5C1.13 11.34 1.08 11.17 1.05 11C1.01 10.82 1 10.65 1 10.47L1 4.19C1 4.02 1.02 3.84 1.06 3.67C1.09 3.5 1.15 3.33 1.22 3.17C1.29 3.01 1.37 2.86 1.47 2.71C1.57 2.57 1.68 2.43 1.81 2.31C1.93 2.19 2.07 2.08 2.22 1.98C2.36 1.88 2.52 1.8 2.68 1.74C2.84 1.67 3.01 1.62 3.19 1.59C3.36 1.55 3.53 1.54 3.71 1.54C3.89 1.54 4.06 1.55 4.23 1.59C4.41 1.62 4.57 1.67 4.74 1.74C4.9 1.8 5.06 1.88 5.2 1.98C5.35 2.08 5.49 2.19 5.61 2.31C5.74 2.43 5.85 2.57 5.95 2.71C6.05 2.86 6.13 3.01 6.2 3.17C6.27 3.33 6.33 3.5 6.36 3.67C6.4 3.84 6.42 4.02 6.42 4.19L6.42 10.47C6.42 10.65 6.41 10.82 6.37 11C6.34 11.17 6.28 11.34 6.22 11.5C6.15 11.67 6.06 11.82 5.97 11.97C5.87 12.12 5.75 12.25 5.63 12.38C5.5 12.51 5.36 12.62 5.22 12.72C5.07 12.82 4.91 12.9 4.75 12.97C4.58 13.04 4.41 13.09 4.24 13.12C4.06 13.16 3.89 13.17 3.71 13.17ZM3.71 3.14C3.57 3.14 3.43 3.16 3.3 3.22C3.17 3.27 3.06 3.35 2.96 3.45C2.86 3.54 2.78 3.66 2.73 3.79C2.67 3.92 2.65 4.05 2.64 4.2L2.64 10.47C2.64 10.62 2.66 10.75 2.72 10.89C2.77 11.02 2.85 11.14 2.95 11.24C3.05 11.34 3.16 11.42 3.29 11.48C3.43 11.54 3.57 11.56 3.71 11.56C3.85 11.56 3.99 11.54 4.12 11.48C4.26 11.42 4.37 11.34 4.47 11.24C4.57 11.14 4.65 11.02 4.7 10.89C4.75 10.75 4.78 10.62 4.77 10.47L4.77 4.2C4.77 4.05 4.75 3.92 4.69 3.79C4.64 3.66 4.56 3.54 4.46 3.44C4.36 3.34 4.25 3.27 4.12 3.21C3.99 3.16 3.85 3.14 3.71 3.14Z"
                                fill="currentColor"
                              />
                              <path
                                id="path"
                                d="M9.09 18.95C9.04 18.95 8.99 18.95 8.93 18.95C8.75 18.93 8.57 18.89 8.4 18.83C8.23 18.77 8.07 18.69 7.92 18.58C7.78 18.48 7.64 18.35 7.53 18.21C7.42 18.07 7.32 17.92 7.25 17.75L5.31 13.26C4.95 12.44 4.77 11.58 4.77 10.69L4.77 4.61C4.77 4.37 4.8 4.14 4.84 3.9C4.89 3.67 4.96 3.45 5.05 3.23C5.14 3.01 5.25 2.8 5.39 2.6C5.52 2.4 5.67 2.22 5.84 2.05C6.01 1.89 6.19 1.74 6.39 1.61C6.58 1.47 6.79 1.36 7.01 1.27C7.23 1.18 7.46 1.11 7.69 1.07C7.93 1.02 8.16 1 8.4 1L11.24 1C11.71 1 12.18 1.05 12.64 1.16C13.1 1.28 13.54 1.44 13.97 1.66C14.39 1.88 14.78 2.14 15.13 2.46C15.49 2.77 15.8 3.12 16.08 3.5L17.71 5.82C18.13 6.43 18.46 7.08 18.68 7.79C18.91 8.5 19.02 9.22 19.02 9.96C19.02 10.21 18.99 10.45 18.95 10.69C18.9 10.93 18.83 11.16 18.73 11.38C18.64 11.61 18.53 11.82 18.39 12.03C18.25 12.23 18.1 12.42 17.92 12.59C17.75 12.76 17.56 12.92 17.36 13.05C17.15 13.19 16.94 13.3 16.71 13.4C16.49 13.49 16.25 13.56 16.01 13.61C15.77 13.66 15.53 13.68 15.28 13.68L12.54 13.68C12.37 13.68 12.21 13.71 12.05 13.78C11.89 13.84 11.75 13.94 11.63 14.06C11.51 14.18 11.42 14.32 11.35 14.48C11.29 14.63 11.26 14.8 11.26 14.97L11.26 16.71C11.25 17.09 11.15 17.43 10.95 17.75L10.78 18.02C10.6 18.31 10.36 18.54 10.06 18.7C9.76 18.87 9.43 18.95 9.09 18.95ZM8.4 2.64C8.27 2.64 8.14 2.65 8.01 2.68C7.88 2.7 7.76 2.74 7.64 2.79C7.52 2.84 7.41 2.9 7.3 2.97C7.19 3.04 7.09 3.12 7 3.21C6.91 3.31 6.83 3.41 6.75 3.51C6.68 3.62 6.62 3.73 6.57 3.85C6.52 3.97 6.48 4.1 6.46 4.22C6.43 4.35 6.42 4.48 6.42 4.61L6.42 10.69C6.42 11.35 6.55 11.99 6.82 12.6L8.76 17.1C8.82 17.23 8.92 17.3 9.06 17.31C9.2 17.32 9.31 17.26 9.39 17.14L9.56 16.87C9.59 16.83 9.61 16.77 9.61 16.71L9.61 14.96C9.61 14.77 9.63 14.58 9.66 14.39C9.7 14.2 9.76 14.02 9.83 13.84C9.9 13.66 10 13.5 10.1 13.34C10.21 13.18 10.33 13.03 10.47 12.89C10.6 12.76 10.75 12.63 10.91 12.53C11.07 12.42 11.24 12.33 11.42 12.26C11.6 12.18 11.78 12.13 11.97 12.09C12.16 12.05 12.35 12.03 12.55 12.03L15.28 12.03C15.42 12.03 15.56 12.02 15.69 11.99C15.82 11.97 15.96 11.93 16.08 11.87C16.21 11.82 16.33 11.76 16.44 11.68C16.56 11.61 16.66 11.52 16.76 11.42C16.85 11.33 16.94 11.22 17.02 11.11C17.09 11 17.16 10.88 17.21 10.75C17.26 10.62 17.3 10.5 17.33 10.36C17.35 10.23 17.37 10.09 17.37 9.96C17.37 9.38 17.28 8.83 17.11 8.28C16.94 7.74 16.69 7.23 16.36 6.76L14.73 4.44C14.53 4.16 14.3 3.91 14.04 3.69C13.79 3.46 13.51 3.27 13.2 3.11C12.9 2.96 12.58 2.84 12.25 2.76C11.92 2.68 11.58 2.63 11.24 2.63L8.4 2.64Z"
                                fill="currentColor"
                              />
                            </svg>
                          </el-tooltip>
                        </div>
                      </template>
                    </div>
                    <template v-if="item.stopCreate&&inx === curIndex&&!item.isError">
                      <div class="right-icons--box" @click="handleContinue(item)">
                        <div class="icons el-icon-refresh-right"></div>
                        <div>继续生成</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--底部的输入框-->
          <div class="dialog-box">
            <div class="new-dialog--box">
              <el-button
                class="btn"
                size="small"
                icon="el-icon-chat-dot-round"
                type="primary"
                plain
                round
                @click="resetChat"
              >新对话</el-button>
            </div>
            <div class="input-content">
              <el-input
                class="text-cont"
                type="textarea"
                :rows="6"
                placeholder="给有教灵境AI智能体发送消息"
                v-model="sendMessage"
                @keydown.native="enterSendMsg($event)"
              ></el-input>
              <div class="btn-group">
                <el-button
                  class="btn-file"
                  type="text"
                  icon="el-icon-paperclip"
                  circle
                  @click="sendImgMsg"
                ></el-button>
                <!--禁止发送-->
                <template v-if="btnMsg">
                  <!--停止生成-->
                  <template v-if="!btnStop">
                    <el-tooltip content="请输入你的问题" placement="top" v-tooltipHide :hide-after="1500">
                      <el-button
                        class="btn is-disabled"
                        type="primary"
                        icon="el-icon-top"
                        circle
                        disabled
                      ></el-button>
                    </el-tooltip>
                  </template>
                  <template v-else>
                    <el-tooltip
                      content="停止生成"
                      v-model="showTip"
                      placement="top"
                      v-tooltipHide
                      :hide-after="1500"
                    >
                      <el-button class="btn" type="primary" circle @click="stopChat">
                        <div class="stop-icon"></div>
                      </el-button>
                    </el-tooltip>
                  </template>
                </template>
                <!--可以发送-->
                <template v-else>
                  <el-button class="btn" type="primary" icon="el-icon-top" circle @click="sendMsg"></el-button>
                </template>
              </div>
            </div>
            <div class="tip-text">内容由AI生成,请仔细甄别.</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-footer class="el-footer">
      <Footer></Footer>
    </el-footer>-->
    <el-dialog
      title="反馈"
      :visible.sync="feedbackVisible"
      width="35%"
      class="feedback-dialog"
      append-to-body
    >
      <div class="dialogbody">
        <el-input
          class="text-cont"
          type="textarea"
          :rows="9"
          placeholder="我们想知道你对此回答不满意的原因，你认为更好的回答是什么？"
          v-model="feedbackContent"
        ></el-input>
      </div>
      <div class="dialogfooter">
        <el-button size="medium" @click="handleClose()">取消</el-button>
        <el-button size="medium" type="primary" @click="handleSubmit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Backtop } from 'element-ui'
import { getToken } from "@/utils/auth"
import { getWStoken } from "@/api/common"
// import Footer from "@/views/Footer"
export default {
  name: "AI",
  components: {
    // Footer,
    'el-backtop': Backtop
  },
  data () {
    return {
      initWs: false,      // websocket链接是否成功
      payloadData: {},    // 接收当前ws服务器的返回数据
      heartTimer: null,   // ws心跳
      wsToken: "",
      sendMessage: "",    // 当前用户发送的key
      wsUrl: "wss://wss.lke.cloud.tencent.com/v1/qbot/chat/conn/?EIO=4&transport=websocket",
      socket: null,       // 建立的websocket
      message: "",        // 接收到的reply消息
      refMessage: "",     // 接收到的reference消息
      speed: 50,          // 用于控制输出ai的reply速度
      btnMsg: true,       // 监听当前用户是否可以发送消息
      btnStop: false,     // 用于切换发送按钮和停止生成按钮
      initChat: false,    // 用于切换欢迎页面和问答页面
      currentIndex: 0,    // 用于接收ai回复的内容
      chatList: [],       // 用于存放用户和ai回复的内容
      replyStat: false,   // 监听ai是否完成回复
      thoughtStat: false, // 监听ai是否思考完成
      curIndex: 0,        // 当前问题的下标
      showTip: false,
      feedbackVisible: false,
      feedbackContent: "",
      row_record_id: "",
    }
  },
  computed: {},
  watch: {
    sendMessage: {
      handler (newV) {
        if (!newV) {
          this.btnMsg = true
        } else {
          this.btnMsg = false
        }
      },
      immediate: true,
      deep: true
    },
    initWs: { // 监听websocket链接成功
      handler (newV) {
        if (newV) {
          this.initWStoken()
        }
      },
      immediate: true,
      deep: true
    },
    replyStat: {
      handler (newV) {
        if (Array.isArray(this.refMessage) && this.refMessage.length) {
          if (newV) {
            let sourceList = []
            this.refMessage.forEach(item => {
              sourceList.push({
                url: item.url,
                name: item.name
              })
            })
            this.chatList[this.curIndex].initSource = true // 用于刷新信息来源数据
            this.chatList[this.curIndex].sourceList = sourceList
          }
        }
      },
      immediate: true,
      deep: true
    },
  },
  created () { },
  mounted () {
    this.connectWebSocket()
  },
  beforeDestroy () {
    this.resetTimer()
    if (this.socket) {
      this.socket.close()
    }
  },
  methods: {
    async initWStoken () {
      let param = {
        token: getToken()
      }
      await getWStoken(param).then(res => {
        this.wsToken = res.data.Token
        this.socket.send(`40{ "token": "${this.wsToken}" }`)
      }).catch((error) => { })
    },
    decJson (res) {
      let newRes = ""
      if (res.includes("[")) {
        let index = res.indexOf("[")
        newRes = res.slice(index)
      }
      return newRes
    },
    // 连接 WebSocket
    connectWebSocket () {
      let that = this
      // 替换为你的 WebSocket 服务器地址
      that.socket = new WebSocket(that.wsUrl)
      // 监听连接成功
      that.socket.onopen = () => {
        that.initWs = true
        console.log("WebSocket 连接成功")
      }
      // 监听消息
      that.socket.onmessage = (event) => {
        let res = event.data
        if (res === "2") {
          that.socket.send(JSON.stringify(3))
        }
        let curElem = that.chatList[that.curIndex]
        if (curElem?.stopCreate) {
          return false
        }
        if (res.includes("error")) { // ai错误时的流程阻断和输出
          let resError = that.decJson(res)
          const errWsJson = JSON.parse(resError)[1]
          let resErrJson = errWsJson.payload
          that.$message.error(resErrJson.error.message)
          that.btnMsg = true
          that.btnStop = false
          that.chatList[that.curIndex].stopCreate = true
          that.chatList[that.curIndex].isError = true
          return false
        }
        if (res.includes("thought")) { // 解析ai思考问题的结果
          let thinkTime = 0
          curElem.timer = 0
          let thoughtRes = that.decJson(res)
          const thoughtWsJson = JSON.parse(thoughtRes)[1]
          that.thoughtStat = false
          curElem.thoughtWsArr = thoughtWsJson.payload.procedures
          curElem.thoughtWsArr.forEach(item => {
            thinkTime = item.elapsed + thinkTime
            if (item.status === "processing") {
              curElem.isThinking = true
              that.thoughtStat = false
            } else if (item.status === "success") {
              setTimeout(() => {
                let endThounght = curElem.thoughtWsArr.every(item => item.status === "success")
                if (endThounght) {
                  curElem.timer = Math.floor(thinkTime / 1000)
                  that.thoughtStat = true
                  curElem.isThinking = false
                }
              }, 500)
            }
          })
        }
        //判断ai开始统计
        if (res.includes("token_stat")) {
          if (!res.includes("thought")) {
            curElem.timer = 0
            that.thoughtStat = true
            curElem.isThinking = false
          }
          curElem.record_id = ""
          let statRes = that.decJson(res)
          const statWsJson = JSON.parse(statRes)[1]
          curElem.record_id = statWsJson.payload.record_id
          that.payloadData = statWsJson.payload
          if (statWsJson.payload.token_count > 0 && statWsJson.payload.status_summary === "success") {
            that.replyStat = true
            that.btnStop = false
            that.btnMsg = true
          } else {
            that.replyStat = false
            that.btnStop = true
          }
        }
        if (res.includes("reply")) { // 解析ai回复
          let newRes = that.decJson(res)
          const wsJson = JSON.parse(newRes)[1]
          that.message = wsJson.payload.content
          if (that.thoughtStat) {
            curElem.lonading = false
            that.startTyping() // 开始模拟打印
          }
        }
        if (res.includes("reference")) { // 解析ai回复问题的来源
          let refeRes = that.decJson(res)
          const refWsJson = JSON.parse(refeRes)[1]
          that.refMessage = refWsJson.payload.references
        }
        if (res.includes("thought") || res.includes("token_stat") || res.includes("reply") || res.includes("reference")) {
          that.scrollToBottom()
        }
      }
      // 监听连接关闭
      that.socket.onclose = () => {
        that.initWs = false
        console.log("WebSocket 连接关闭")
        that.connectWebSocket()
      }
      // 监听错误
      that.socket.onerror = (error) => {
        that.initWs = false
        console.error("WebSocket 错误:", error)
        that.connectWebSocket()
      }
    },
    wsSendMessage (data) {
      // 获取当前时间戳
      let timestamp = new Date().getTime()
      let uid = this.generateUniqueId(timestamp)
      let cutTokenStr = getToken().slice(0, 20)
      let msg = {
        payload: {
          request_id: `${cutTokenStr}-${uid}`,
          session_id: this.generateUniqueId(timestamp + 1000),
          content: data ? data : this.sendMessage,
        }
      }
      let msgInfo = JSON.stringify([`"send"`, JSON.stringify(msg)])
      let info = `42[${JSON.parse(msgInfo)}]`
      this.socket.send(info)
    },
    startWs (newSocket) {
      this.heartTimer && clearTimeout(this.heartTimer)
      this.heartTimer = setTimeout(() => {
        newSocket.send(JSON.stringify(3))
        this.startWs(newSocket)
      }, 5000)
    },
    resetTimer () {
      this.heartTimer && clearTimeout(this.heartTimer)
    },
    handleBack () {
      if (this.chatList?.length) {
        this.resetChat()
      }
      this.$router.push({
        path: "/home"
      })
    },
    resetChat () {
      this.stopChat()
      this.chatList?.forEach(item => { // 为了隐藏继续生成的按钮
        item.stopCreate = false
      })
      setTimeout(() => {
        this.initChat = false
        this.chatList = []
      }, 300)
    },
    sendImgMsg () {

    },
    scrollToBottom () {
      const container = this.$refs.chatBoxCont
      container.scrollTop = container.scrollHeight
    },
    sendMsg () {
      if (this.btnMsg) { // 用户未输入key
        return false
      } else if (this.btnStop) { // 如果正在生成答案
        this.showTip = true
        setTimeout(() => {
          this.showTip = false
        }, 500)
        return false
      }
      this.payloadData = {}
      this.btnStop = false
      this.thoughtStat = false // 每次发送消息重置ai思考
      this.initChat = true
      this.message = ""
      this.currentIndex = 0
      this.refMessage = ""
      this.$nextTick(() => {
        this.chatList.push({ key: this.sendMessage, initSource: false, isThinking: true, showThink: true, stopCreate: false, thoughtWsArr: [], isError: false, lonading: true, })
        this.wsSendMessage()
        this.sendMessage = ""
        this.curIndex = this.chatList.length - 1
      })
    },
    enterSendMsg (event) {
      if (event.keyCode === 13) {
        this.sendMsg()
        event.preventDefault()
        return false
      }
    },
    startTyping () {
      const element = this.$refs[`output${this.curIndex}`][0]
      let startReply = setInterval(() => {
        if (this.currentIndex < this.message.length) {
          element.textContent += this.message.charAt(this.currentIndex)
          this.currentIndex++
        } else {
          clearInterval(startReply)
        }
      }, this.speed)
    },
    generateUniqueId (timestamp) {
      // 生成一个随机数
      const randomNum = Math.floor(Math.random() * 1000000)
      // 生成一个唯一标识符
      const uniqueId = `${timestamp}-${randomNum}`
      return uniqueId
    },
    stopChat () {
      this.btnStop = false
      let msg = {
        payload: {
          record_id: this.payloadData.record_id,
        }
      }
      let msgInfo = JSON.stringify([`"stop_generation"`, JSON.stringify(msg)])
      let info = `42[${JSON.parse(msgInfo)}]`
      this.socket.send(info) // 发送停止指令
      let elem = this.chatList[this.curIndex]
      elem.stopCreate = true
    },
    handleContinue (row) {
      row.isError = false
      row.stopCreate = false
      this.wsSendMessage(row.key)
    },
    handleCopy (i) { // 复制ai的回复内容
      const elem = this.$refs[`output${i}`][0]
      const text = elem.innerHTML
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
      } else {
        let input = document.createElement('input')
        input.value = text
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
      }
    },
    resetContinue (row, i) {
      this.chatList.splice(i + 1)
      this.curIndex = i
      row.initSource = false
      row.isThinking = true
      row.stopCreate = false
      row.thoughtWsArr = []
      row.sourceList = []
      row.isError = false
      this.payloadData = {}
      this.replyStat = false
      this.thoughtStat = false
      this.btnStop = false
      this.message = ""
      this.refMessage = ""
      this.currentIndex = 0
      const element = this.$refs[`output${this.curIndex}`][0]
      element.textContent = ""
      this.wsSendMessage(row.key)
    },
    changeThinkStat (row) {
      row.showThink = !row.showThink
    },
    giveLike (row) {
      let msg = {
        payload: {
          record_id: row.record_id,
          score: 1
        }
      }
      let msgInfo = JSON.stringify([`"rating"`, JSON.stringify(msg)])
      let info = `42[${JSON.parse(msgInfo)}]`
      this.socket.send(info) // 发送点赞指令
    },
    handleDisagree (row) {
      this.row_record_id = row.record_id
      this.feedbackVisible = true
    },
    handleSubmit () {
      let msg = {
        payload: {
          record_id: this.row_record_id,
          score: 2,
          reasons: [this.feedbackContent]
        }
      }
      let msgInfo = JSON.stringify([`"rating"`, JSON.stringify(msg)])
      let info = `42[${JSON.parse(msgInfo)}]`
      this.socket.send(info) // 发送点踩指令
      this.handleClose()
    },
    handleClose () {
      this.row_record_id = ""
      this.feedbackContent = ""
      this.feedbackVisible = false
    }
  },
};
</script>
<style scoped lang="scss">
.container {
  // position: relative;
  background-color: #f9f9f9;
  flex-direction: column;
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  .top-cont {
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #ebeef5;
    padding: 0px 5%;
    .btn-cont {
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
  .content-box--wrap {
    flex-grow: 1;
    position: relative;
    .content-box {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      overflow: auto;
      // padding: 0px 30px;
      .content {
        width: 100%;
        max-width: 960px;
        margin: auto;
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }
    .tip-cont {
      padding: 30px 0px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        // background-color: #3d84ff;
        height: 46px;
        line-height: 46px;
        border-radius: 23px;
        text-align: center;
        color: #000;
        padding: 0px 24px;
        font-size: 26px;
      }
      .tag {
        background-color: #ccc;
        text-align: center;
        color: #fff;
        height: 26px;
        line-height: 26px;
        border-radius: 13px;
        padding: 0px 10px;
        font-size: 14px;
        margin: 24px 0px 32px;
      }
      .text {
        // font-weight: bold;
        color: #333;
        font-size: 14px;
      }
    }
    .chat-cont {
      // height: 100%;
      padding-top: 20px;
      box-sizing: border-box;
      flex-grow: 1;
      .item-chat--box {
        .user-key--cont {
          color: #333;
          font-size: 16px;
          display: flex;
          justify-content: flex-end;
          margin-bottom: 20px;
          .user-key {
            color: #262626;
            padding: 12px 18px;
            box-sizing: border-box;
            white-space: pre-wrap;
            word-break: break-word;
            background-color: #fff;
            border-radius: 8px;
            position: relative;
          }
        }
        .item-chat {
          padding-left: 50px;
          position: relative;
          .avatar {
            width: 34px;
            height: 34px;
            position: absolute;
            left: 8px;
            top: 0px;
            .el-avatar {
              width: 100%;
              height: 100%;
            }
          }
          .answer-cont {
            .loading-cont {
              user-select: none;
              border-radius: 8px;
              justify-content: center;
              align-items: center;
              width: fit-content;
              padding: 8px 16px;
              display: flex;
              background-color: #efefef;
              font-size: 14px;
              cursor: pointer;
              i {
                font-size: 16px;
                margin-right: 6px;
              }
              svg {
                margin-right: 4px;
              }
              .thinkIcon {
                margin-left: 6px;
              }
            }
          }
        }
      }
      .item-chat--box:not(:last-child) {
        margin-bottom: 20px;
      }
      .thought-cont {
        padding-left: 14px;
        border-left: 2px solid #e5e5e5;
        .thought-text {
          white-space: pre-wrap; /* 保留换行和空格 */
          // font-family: monospace; /* 使用等宽字体 */
          color: #8b8b8b;
          font-size: 14px;
          line-height: 1.6;
          // font-family: 'Microsoft YaHei', Arial, sans-serif;
        }
      }
      .desc-cont {
        .desc-text {
          white-space: pre-wrap; /* 保留换行和空格 */
          // font-family: monospace; /* 使用等宽字体 */
          color: #333;
          font-size: 14px;
          line-height: 1.6;
        }
        ::v-deep .el-loading-spinner {
          display: flex;
          justify-content: center;
          align-items: center;
          .el-icon-loading,
          .el-loading-text {
            color: #000;
          }
          .el-loading-text {
            transform: translate(6px, 0px);
          }
        }
      }
      .refe-cont {
        .refe-text {
          white-space: pre-wrap; /* 保留换行和空格 */
          // font-family: monospace; /* 使用等宽字体 */
          font-size: 14px;
          line-height: 2.2;
          ::v-deep .el-link--inner {
            display: flex;
            position: relative;
            .name:hover {
              text-decoration: underline;
            }
          }
          .icons-cont {
            color: #409eff;
            display: flex;
            svg {
              transform: translateY(8px);
            }
            span {
              margin: 0px 8px;
            }
          }
        }
      }
      .tool-cont {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left-icons--box {
          display: flex;
          align-items: center;
          gap: 12px;
          .icons {
            font-size: 20px;
            color: #909090;
            cursor: pointer;
            font-weight: 590;
            display: flex;
          }
        }
        .right-icons--box {
          user-select: none;
          border-radius: 8px;
          justify-content: center;
          align-items: center;
          width: fit-content;
          padding: 8px 16px;
          display: flex;
          background-color: #fff;
          font-size: 14px;
          cursor: pointer;
          color: #404040;
          .icons {
            font-size: 18px;
            color: #909090;
            font-weight: 550;
            margin-right: 4px;
            transform: translateY(1px);
          }
        }
      }
      .box {
        margin-bottom: 15px;
      }
    }
    .dialog-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: sticky;
      padding: 20px 0px 40px;
      background-color: #f9f9f9;
      bottom: 0px;
      z-index: 10;
      .new-dialog--box {
        margin-bottom: 16px;
        .btn {
          ::v-deep i {
            font-weight: 400;
            font-size: 16px;
          }
        }
      }
      .input-content {
        width: 100%;
        position: relative;
        .btn-group {
          position: absolute;
          right: 10px;
          bottom: 10px;
          display: flex;
          .stop-icon {
            width: 14px;
            height: 14px;
            margin: 2px;
            border-radius: 2px;
            background-color: #fff;
          }
        }
        .btn-file {
          font-size: 28px;
          color: #4c4c4c;
          padding: 0px;
        }
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 6px;
          ::v-deep i {
            font-size: 18px;
          }
        }
      }
      .tip-text {
        margin-top: 10px;
        font-size: 14px;
        color: #ccc;
      }
    }
  }
  // .el-footer {
  //   position: absolute;
  //   height: 300px !important;
  //   bottom: 0px;
  //   left: 0px;
  //   right: 0px;
  // }
}
.el-button {
  ::v-deep i {
    font-weight: bold;
  }
}
::v-deep .el-textarea__inner {
  resize: none;
  border-color: #ebeef5;
  color: #333;
  &:hover {
    border-color: #c0c4cc;
  }
  &:focus {
    border-color: #409eff;
  }
}
::v-deep .el-dialog {
  border-radius: 10px;
  .el-dialog__body {
    padding-top: 20px;
  }
}
.dialogfooter {
  margin-top: 30px;
  text-align: right;
}
</style>